import React, { useState } from "react";
import { useSelector } from "react-redux";
import WithProductDateProgressSearchComponent from "./withProductDateProgressSearch.component";

export default function WithProductGeneralSearchContainer({
  handleFilter,
  isFetchingProduct,
  productDropdown,
  searchValue = "",
  filterValues = {
    productsSelected: [],
    progressSelected: [],
    startPeriodFrom: null,
    startPeriodTo: null,
    endPeriodFrom: null,
    endPeriodTo: null,
  },
}) {
  const lang = useSelector((state) => state.constant.languages);

  const [productsSelected, setProductsSelected] = useState(
    filterValues.productsSelected
  );
  const [startPeriodRange, setStartPeriodRange] = useState(
    filterValues.startPeriodFrom && filterValues.startPeriodTo
      ? { from: filterValues.startPeriodFrom, to: filterValues.startPeriodTo }
      : null
  );
  const [endPeriodRange, setEndPeriodRange] = useState(
    filterValues.endPeriodFrom && filterValues.endPeriodTo
      ? { from: filterValues.endPeriodFrom, to: filterValues.endPeriodTo }
      : null
  );
  const [progressSelected, setProgressSelected] = useState(
    filterValues.progressSelected
  );

  React.useEffect(() => {
    setProductsSelected(filterValues.productsSelected);
    setProgressSelected(filterValues.progressSelected);
    setStartPeriodRange(
      filterValues.startPeriodFrom && filterValues.startPeriodTo
        ? { from: filterValues.startPeriodFrom, to: filterValues.startPeriodTo }
        : null
    );
    setEndPeriodRange(
      filterValues.endPeriodFrom && filterValues.endPeriodTo
        ? { from: filterValues.endPeriodFrom, to: filterValues.endPeriodTo }
        : null
    );
  }, [filterValues]);

  const handleStartPeriodRangeChange = (value) => {
    if (value) {
      setStartPeriodRange(value);
    } else {
      setStartPeriodRange(null);
    }
  };

  const handleEndPeriodRangeChange = (value) => {
    if (value) {
      setEndPeriodRange(value);
    } else {
      setEndPeriodRange(null);
    }
  };

  const handleSearch = async (searchString) => {
    await handleFilter({
      searchString: searchString,
      product: productsSelected,
      startPeriodFrom: startPeriodRange?.from || null,
      startPeriodTo: startPeriodRange?.to || null,
      endPeriodFrom: endPeriodRange?.from || null,
      endPeriodTo: endPeriodRange?.to || null,
      progress: progressSelected,
    });
  };

  const handleClear = async () => {
    setProductsSelected([]);
    setStartPeriodRange(null);
    setEndPeriodRange(null);
    setProgressSelected([]);
    await handleFilter({
      searchString: "",
      product: [],
      startPeriodFrom: null,
      startPeriodTo: null,
      endPeriodFrom: null,
      endPeriodTo: null,
      progress: [],
    });
  };

  return (
    <WithProductDateProgressSearchComponent
      handleSearch={handleSearch}
      lang={lang}
      isFetching={isFetchingProduct}
      productDropdown={productDropdown}
      productsSelected={productsSelected}
      setProductsSelected={setProductsSelected}
      progressSelected={progressSelected}
      setProgressSelected={setProgressSelected}
      startPeriodRange={startPeriodRange}
      endPeriodRange={endPeriodRange}
      handleStartPeriodRangeChange={handleStartPeriodRangeChange}
      handleEndPeriodRangeChange={handleEndPeriodRangeChange}
      handleClear={handleClear}
      searchValue={searchValue}
    />
  );
}
